import { ExternalType } from "./type.js";
import { externalFactory } from "./externalFactory.js";
import { requestCheckFile } from "./caxa/directive/requestCheckFile.js";
import { kjlRequest } from "./kujiale/initKujiale.js";
const externalRequestCheckFile = externalFactory(async (params) => {
  const { type } = params;
  switch (type) {
    case ExternalType.caxa:
      return await requestCheckFile(params.arg, params.sequenceId);
    case ExternalType.kujiale:
      return await kjlRequest.requestCheckFile(params.arg, params.sequenceId);
    default:
      throw new Error(`\u8BE5\u65B9\u6CD5\uFF0C\u6682\u4E0D\u652F\u6301${type}\u7C7B\u578B\u7684\u5916\u90E8\u7CFB\u7EDF`);
  }
});
export { externalRequestCheckFile };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/external/externalRequestCheckFile.js